// extracted by mini-css-extract-plugin
export default {"user-form":"user-form_RxNia"};